import styled, { css } from 'styled-components';
import { StyledContainer as Container } from '../Container/container.styles';
import { StyledParagraph as Paragraph } from '../Typography/typography.styles';

export const StyledFooter = styled.footer`
  margin-top: 32px;
  border-top: ${({ theme }) => `1px solid ${theme.palette.primary.gray}`};
  background-color: ${({ theme }) => theme.palette.surface.primary};
`;
export const StyledContainer = styled(Container)`
  display: flex;
  gap: 32px;
  justify-content: space-between;
  margin-bottom: 0;
  padding: 32px 24px;

  ${({ theme }) => css`
    ${theme.media.mobile} {
      align-items: center;
      flex-direction: column;
      gap: 16px;
    }
  `}
`;
export const StyledBox = styled.div`
  margin: 0;
`;
export const StyledParagraph = styled(Paragraph)`
  margin-bottom: 16px;
  display: flex;
  align-items: center;
`;
